import { render } from "./myqiandao.vue?vue&type=template&id=9cf5b8dc&scoped=true"
import script from "./myqiandao.vue?vue&type=script&lang=js"
export * from "./myqiandao.vue?vue&type=script&lang=js"

import "./myqiandao.vue?vue&type=style&index=0&id=9cf5b8dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf5b8dc"]])

export default __exports__